import { useEffect, useMemo, useState } from 'react'

import { WysiwygEditorConfig } from '../components/InputTranslator/InputTranslatorDialog/InputTranslatorDialog'
import { screenshotLinkGameIdOption, screenshotLinkPluginName } from '../helpers/screenshotLinks'

const plugins = ['link', 'lists', 'searchreplace', 'code', 'autoresize']
const toolbar = (insert: string) => `undo redo removeformat | blocks blockquote | outdent indent | bold italic underline bullist${insert} | code`

/**
 * The WYSIWYG config with the screenshot link button for a game's texts. Undefined until the plugin is registered,
 * because an editor initialised before that fails on the unknown plugin. If the plugin can't be loaded, the config has no button.
 */
export const useScreenshotLinkEditorConfig = (gameId?: string | null): WysiwygEditorConfig | undefined => {
  const [state, setState] = useState<'loading' | 'registered' | 'failed'>('loading')

  useEffect(() => {
    let active = true
    import('../components/InputTranslator/InputTranslatorDialog/ScreenshotLinkPlugin')
      .then((module) => {
        module.default()
        if (active) setState('registered')
      })
      .catch(() => active && setState('failed'))
    return () => {
      active = false
    }
  }, [])

  return useMemo(() => {
    if (state === 'loading' || !gameId) return undefined
    if (state === 'failed') return { plugins, toolbar: toolbar('') }
    return {
      plugins: [...plugins, screenshotLinkPluginName],
      toolbar: toolbar(` | ${screenshotLinkPluginName}`),
      init: { [screenshotLinkGameIdOption]: gameId },
    }
  }, [gameId, state])
}
